// extracted by mini-css-extract-plugin
export default {"melodyVideo":"TH-z","isFullWidth":"UH-z","landingPageVideo":"VH-z","play":"WH-z","iframeVideo":"XH-z","playHidden":"YH-z","fullwidth":"ZH-z"};